<template>
  <div class="page">
    <div class="group_1">
      <div class="header">
        <div class="header_left">
          <div class="text_1">当前余额</div>
          <div class="text_2"><span class="text_3">￥</span>{{ Number(this.userBalance).toFixed(2)||0 }}</div>
        </div>
        <div class="header_right">
          <div class="icon"><img src="../../assets/new/money.png" alt="" /></div>
          <div class="text_4">*余额可在平台购课时抵扣，不支持提现</div>
        </div>
      </div>
      <div class="box_1">
        <van-tabs @click="onClick" color="#2A70F2" title-active-color="#2A70F2">
          <van-tab title="收入记录" class="text_5">
            <div class="box_2">
              <div class="title_1">
                <span>收入类型</span>
                <span>收入时间</span>
                <span>收入金额</span>
              </div>
              <div class="info" v-if="list.length>0">
                <div class="box_3" v-for="item in list" :key="item.ID">
                  <span>{{item.TYPE=='01'?'充值':'消费'||''}}</span>
                  <span style="text-align: center;width: 150px;">{{item.DEPOSIT_TIME||''}}</span>
                  <span style="text-align: right">{{item.DEPOSIT_AMOUNT.toFixed(2)||0}}元</span>
                </div>
              
              </div>
              <div v-else style="text-align: center;font-size: 14px;color: #999;margin-top: 20px;">暂无数据~</div>
            </div>
          </van-tab>
          <van-tab title="支出记录">
            <div class="box_2">
              <div class="title_1">
                <span>支出类型</span>
                <span>支出时间</span>
                <span>支出金额</span>
              </div>
              <div class="info" v-if="list.length>0">
              
                   <div class="box_3" v-for="item in list" :key="item.ID">
                  <span>{{item.TYPE=='02'?'消费':'充值'||''}}</span>
                  <span style="text-align: center;width: 150px;">{{item.DEPOSIT_TIME||''}}</span>
                  <span style="text-align: right">{{Number(item.DEPOSIT_AMOUNT).toFixed(2)||0}}元</span>
                </div>
              </div>
              <div v-else style="text-align: center;font-size: 14px;color: #999;margin-top: 20px;">暂无数据~</div>

            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toMyAccount } from '../../api/my';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      userBalance: '', //余额
      type: '01', //01表示充值 02表示消费
      list: []
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    onClick(name, title) {
      // Toast(title);
      if (name == '0') {
        this.getAccount('01');
      } else if (name == '1') {
        this.getAccount('02');
      }
      console.log(name, '000');
    },
    //获取账户余额
    getAccount(type) {
      toMyAccount({ type: type }).then(res => {
        this.userBalance = res.data.data.userBalance;
        this.list= res.data.data.list.rows
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getAccount(this.type);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
}
.group_1 {
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
}
.header {
  width: 100%;
  height: 96px;
  background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
  border-radius: 8px 8px 8px 8px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
}
.header_left {
  .text_1 {
    margin-top: 7px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
  }
  .text_2 {
    font-family: DIN, DIN;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
    margin-top: 2px;
  }
  .text_3 {
    font-size: 13px;
  }
}
.header_right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
  .icon {
    position: absolute;
    top: 0;
    right: 6px;
    height: 62px;
    width: 62px;
    img {
      height: 62px;
      width: 62px;
    }
  }
  .text_4 {
    margin-top: 47px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #ffffff;
  }
}
.box_1 {
  margin-top: 10px;
  // width: 345px;
  height:auto;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 14px 15px;
}
::v-deep {
  .van-tabs__wrap {
    border-bottom: 1px solid #eeeeee;
  }
  .van-tabs__line {
    margin-bottom: 10px;
    width: 24px;
    height: 2px;
    border-radius: 2px 2px 2px 2px;
  }
  .van-tab {
    border-right: 1px solid #eeeeee;
    height: 20px;
  }
  .van-tab:nth-child(2) {
    border-right: 0;
  }
}
.box_2 {
  .title_1 {
    margin-top: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #667280;
    display: flex;
    justify-content: space-between;
  }
}
.info {
  margin-top: 16px;
  .box_3 {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    span {
      width: 100px;
    }
  }
}
</style>
